import { useEffect, useRef } from 'react'
import { useQuery } from '@tanstack/react-query'

export function useRunOnceEffect<T>(
  key: string,
  value: T,
  sideEffect: () => T | Promise<T>,
  valueSetter: (value: T) => void,
) {
  const currentValueRef = useRef(value)

  useEffect(() => {
    currentValueRef.current = value
  }, [value])

  useQuery({
    queryKey: ['update-once', key],
    queryFn: async () => {
      const updatedValue = await sideEffect()
      if (currentValueRef.current !== value) {
        return null
      }

      valueSetter(updatedValue)
      return updatedValue
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: true,
    staleTime: Infinity,
    cacheTime: Infinity,
  })
}
